import React from 'react'
import { CardGroup, Card, Row, Col, } from 'react-bootstrap';
import '../mysass.scss';

const About = () => {
  return (
<>



    <CardGroup id='about' className="anchorsabout m-0 d-block" >
          <Card className="imageaboutkosovo m-0 border-0 shadow">
            <Row>
              <Col>
                <Card.Img className='kosovoflag' src="kosovoflag1.jpg" 
                style={{objectFit: 'cover'}} />
              </Col>
              <Col>
                <Card.Body>
                <Card.Title style={{textAlign:'center',fontSize:'18px'}}>
                  <h2 style={{fontFamily: 'Black Ops One, cursive',color:'#0074D9'}}>KOSOVO</h2>
                  </Card.Title>
                <br/>
                <Card.Text as="h4">
                <h6>Area: <b>10.887km<sup>2</sup></b></h6>
                  <h6>Capital: <b>Prishtina</b></h6>
                  <h6>Population: <b>1,761,985</b></h6>
                  <h6>Declaration of independence: <b>17 February 2008</b></h6>
                  <h6>Currency: <b>Euro € </b></h6>
                  <h6 style={{fontSize:'14px'}}><b>Kosovo</b> officially the Republic of Kosovo is a country 
                    in Southeast Europe with partial diplomatic recognition. 
                    Kosovo lies landlocked in the center of the Balkans, bordered 
                    by Serbia to the north and east, North Macedonia to the southeast, 
                    Albania to the southwest, and Montenegro to the west. Most of central 
                    Kosovo is dominated by the vast fields. The Bjeshket e Nemuna Mountains
                    and Sharr Mountains rise in the southwest and southeast, respectively.
                    Kosovo unilaterally declared its independence on 17 February 2008, 
                    and has since gained diplomatic recognition as a sovereign state by 
                    101 member states of the United Nations. 
                    </h6>             
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>

</>
  )
}

export default About